(function() {
  // === DEFENSIVE: full-width parent, hide theme title, move overlay to body root ===
  function fixContainers() {
    var el = document.querySelector('.crossings-page');
    if (!el) return;
    var parent = el.parentElement;
    while (parent && parent !== document.body) {
      var cls = parent.className || '';
      if (cls.indexOf('page-width') !== -1 || cls.indexOf('rte') !== -1 || parent.tagName === 'ARTICLE') {
        parent.style.maxWidth = '100%';
        parent.style.width = '100%';
        parent.style.paddingLeft = '0';
        parent.style.paddingRight = '0';
      }
      parent = parent.parentElement;
    }
    var section = el.closest('.shopify-section');
    if (section) {
      var themeTitle = section.querySelector('h1:not(.page-header h1), .page-title, .article-template__title');
      if (themeTitle && !el.contains(themeTitle)) themeTitle.style.display = 'none';
    }
    var mainH1 = document.querySelector('main h1');
    if (mainH1 && !el.contains(mainH1)) mainH1.style.display = 'none';

    var overlay = document.getElementById('detailOverlay');
    if (overlay && overlay.parentElement !== document.body) {
      document.body.appendChild(overlay);
    }
  }

  // === STATE ===
  var CROSSINGS = {};
  var LEVELS = {};
  var STAGES = {};
  var CHAKRA = {
    1: {strong: '#c0392b'}, 2: {strong: '#d35400'}, 3: {strong: '#b7950b'},
    4: {strong: '#219a52'}, 5: {strong: '#2471a3'}, 6: {strong: '#5b2c6f'},
    7: {strong: '#7d3c98'}
  };

  var SHOPIFY_DOMAIN = 'summerjiang.com';
  var PRODUCTS_URL = 'https://' + SHOPIFY_DOMAIN + '/products.json?limit=250';

  var artworkMap = null;
  var artworkLoading = false;
  var currentCode = null;

  // === HELPERS ===
  function escHtml(t) {
    if (!t) return '';
    var d = document.createElement('div');
    d.textContent = t;
    return d.innerHTML;
  }

  function section(title, text) {
    if (!text) return '';
    return '<div class="detail-section"><h3>' + escHtml(title) + '</h3><p>' + escHtml(text) + '</p></div>';
  }

  // === ARTWORK FETCH (public /products.json — sees all Online Store products) ===
  // Filtered to Original Paintings only.
  function getProductCode(p) {
    var m = (p.title || '').match(/(?:Crossing|Frequency)\s*:?\s*(\d+\.\d+)/i);
    return m ? m[1] : null;
  }

  function getArtworkName(title) {
    var parts = (title || '').split('|').map(function(s) { return s.trim(); });
    if (parts.length >= 2 && (parts[0] === 'Limited Edition' || parts[0] === 'Original Painting')) {
      return parts[1];
    }
    return parts[0];
  }

  async function loadAllArtwork() {
    if (artworkMap !== null) return artworkMap;
    if (artworkLoading) {
      while (artworkLoading) await new Promise(function(r) { setTimeout(r, 50); });
      return artworkMap || {};
    }
    artworkLoading = true;

    try {
      var resp = await fetch(PRODUCTS_URL, { cache: 'no-cache' });
      if (!resp.ok) { artworkMap = {}; return artworkMap; }
      var data = await resp.json();
      var products = data.products || [];
      var map = {};
      products.forEach(function(p) {
        if (p.product_type !== 'Original Painting') return;
        var code = getProductCode(p);
        if (!code) return;
        var img = (p.images && p.images[0]) || p.image;
        if (!img || !img.src) return;
        if (!map[code]) map[code] = [];
        map[code].push({
          title: getArtworkName(p.title),
          handle: p.handle,
          url: 'https://' + SHOPIFY_DOMAIN + '/products/' + p.handle,
          image: img.src,
          alt: img.alt || p.title
        });
      });
      artworkMap = map;
      markCellsWithArtwork();
      return artworkMap;
    } catch (err) {
      console.warn('Artwork load failed:', err);
      artworkMap = {};
      return artworkMap;
    } finally {
      artworkLoading = false;
    }
  }

  // Add .has-artwork class to cells whose code has at least one Original
  function markCellsWithArtwork() {
    if (!artworkMap) return;
    Object.keys(artworkMap).forEach(function(code) {
      if (!artworkMap[code] || artworkMap[code].length === 0) return;
      document.querySelectorAll('.grid-cell[data-code="' + code + '"]').forEach(function(cell) {
        cell.classList.add('has-artwork');
        cell.setAttribute('data-artwork-count', String(artworkMap[code].length));
      });
    });
  }

  async function fetchArtwork(code) {
    var map = await loadAllArtwork();
    return map[code] || [];
  }

  // === CELL RENDERING (from data) ===
  function renderGrid() {
    var container = document.querySelector('.grid-container');
    if (!container) return;

    // Clear placeholder cells (if any) and rebuild from data
    var existingCells = container.querySelectorAll('.grid-cell');
    if (existingCells.length === 49) return; // already rendered server-side

    // Remove any existing cells & row headers (corner + col headers stay)
    container.querySelectorAll('.grid-cell, .row-header').forEach(function(el) { el.remove(); });

    // Stages 1..7 = rows
    for (var s = 1; s <= 7; s++) {
      var stage = STAGES[s] || {};
      var rh = document.createElement('div');
      rh.className = 'row-header';
      rh.innerHTML = '<span class="header-num">0.' + s + '</span><span class="header-name">' + escHtml(stage.full || stage.name || '') + '</span>';
      container.appendChild(rh);

      // Levels 1..7 = columns
      for (var l = 1; l <= 7; l++) {
        var code = l + '.' + s;
        var c = CROSSINGS[code] || {};
        var color = CHAKRA[l] || {strong: '#333'};
        var cell = document.createElement('div');
        cell.className = 'grid-cell';
        cell.setAttribute('data-code', code);
        cell.setAttribute('data-col', String(l));
        cell.style.background = color.strong.replace('#', 'rgba(') + ', 0.08)'; // fallback only
        // Use tinted background by parsing hex → rgba
        var hex = color.strong;
        var r = parseInt(hex.substr(1, 2), 16);
        var g = parseInt(hex.substr(3, 2), 16);
        var b = parseInt(hex.substr(5, 2), 16);
        cell.style.background = 'rgba(' + r + ',' + g + ',' + b + ',0.08)';
        cell.innerHTML = '<span class="cell-code" style="color:' + color.strong + '">' + code + '</span>' +
                         '<span class="cell-name">' + escHtml(c.name || '') + '</span>';
        container.appendChild(cell);
      }
    }
  }

  // === MODAL ===
  async function openCrossing(code) {
    var c = CROSSINGS[code];
    if (!c) return;
    currentCode = code;

    var parts = code.split('.').map(Number);
    var cl = parts[0], es = parts[1];
    var level = LEVELS[cl] || {};
    var stage = STAGES[es] || {};
    var color = CHAKRA[cl] || {strong: '#333'};

    var artEl = document.getElementById('detailArtwork');
    var loadEl = document.getElementById('artworkLoading');
    artEl.innerHTML = '';
    artEl.classList.remove('has-images');
    loadEl.classList.add('visible');

    var codeEl = document.getElementById('detailCode');
    codeEl.textContent = code;
    codeEl.style.background = color.strong + '15';
    codeEl.style.color = color.strong;

    document.getElementById('detailLevel').textContent = level.full || ('Level ' + cl);
    document.getElementById('detailStage').textContent = '× ' + (stage.full || ('Stage ' + es));
    document.getElementById('detailName').textContent = c.name || '';
    document.getElementById('detailIrony').textContent = c.irony || '';

    var html = '';
    html += section('The State', c.the_state);
    html += section('The Shadow', c.the_shadow);
    html += section('The Gift', c.the_gift);
    html += section('The Illusion', c.the_illusion);
    html += section('The Crossing', c.the_crossing);

    if (c.diagnostic_person || c.diagnostic_society) {
      html += '<hr class="detail-divider">';
      html += section('Diagnostic: Person', c.diagnostic_person);
      html += section('Diagnostic: Society', c.diagnostic_society);
    }

    if (c.social_phenomena || c.cultural_handle) {
      html += '<hr class="detail-divider">';
      html += section('Social Phenomena', c.social_phenomena);
      html += section('Cultural Handle', c.cultural_handle);
    }

    html += '<p class="detail-pagelink"><a href="/pages/crossing-' + code.replace('.', '-') + '">Read the full page for this crossing &rarr;</a></p>';
    document.getElementById('detailBody').innerHTML = html;

    document.getElementById('detailOverlay').classList.add('open');
    document.querySelector('.detail-panel').scrollTop = 0;
    document.body.style.overflow = 'hidden';

    document.querySelectorAll('.grid-cell').forEach(function(el) { el.classList.remove('active'); });
    document.querySelectorAll('.grid-cell[data-code="' + code + '"]').forEach(function(el) { el.classList.add('active'); });

    history.replaceState(null, '', '#' + code.replace('.', '-'));

    var artworks = await fetchArtwork(code);
    loadEl.classList.remove('visible');
    if (currentCode !== code) return;

    if (artworks.length > 0) {
      var thumbsHtml = '<div class="artwork-heading">Related Artwork</div><div class="artwork-row">';
      artworks.forEach(function(a) {
        thumbsHtml += '<a class="artwork-thumb" href="' + escHtml(a.url) + '" target="_blank" rel="noopener">' +
          '<img src="' + escHtml(a.image) + '" alt="' + escHtml(a.alt) + '" loading="lazy">' +
          '<span>' + escHtml(a.title) + '</span></a>';
      });
      thumbsHtml += '</div>';
      artEl.innerHTML = thumbsHtml;
      artEl.classList.add('has-images');
    }
  }

  function closeCrossing() {
    document.getElementById('detailOverlay').classList.remove('open');
    document.body.style.overflow = '';
    document.querySelectorAll('.grid-cell').forEach(function(el) { el.classList.remove('active'); });
    var loadEl = document.getElementById('artworkLoading');
    if (loadEl) loadEl.classList.remove('visible');
    currentCode = null;
    history.replaceState(null, '', window.location.pathname);
  }

  function navigateCrossing(dir) {
    if (!currentCode) return;
    var parts = currentCode.split('.').map(Number);
    var cl = parts[0], es = parts[1];
    var newCl = cl;
    var newEs = es + dir;
    if (newEs > 7) { newEs = 1; newCl = cl < 7 ? cl + 1 : 1; }
    else if (newEs < 1) { newEs = 7; newCl = cl > 1 ? cl - 1 : 7; }
    openCrossing(newCl + '.' + newEs);
  }

  // === EVENT WIRING ===
  function wireEvents() {
    document.querySelectorAll('.grid-cell').forEach(function(cell) {
      cell.addEventListener('click', function() {
        var code = this.getAttribute('data-code');
        if (code) openCrossing(code);
      });
    });

    var overlay = document.getElementById('detailOverlay');
    if (overlay) {
      overlay.addEventListener('click', function(e) {
        if (e.target === this) closeCrossing();
      });
    }

    var closeBtn = document.getElementById('detailClose');
    if (closeBtn) closeBtn.addEventListener('click', closeCrossing);

    var prevBtn = document.getElementById('navPrev');
    if (prevBtn) prevBtn.addEventListener('click', function() { navigateCrossing(-1); });

    var nextBtn = document.getElementById('navNext');
    if (nextBtn) nextBtn.addEventListener('click', function() { navigateCrossing(1); });

    document.addEventListener('keydown', function(e) {
      var ov = document.getElementById('detailOverlay');
      if (!ov || !ov.classList.contains('open')) return;
      if (e.key === 'Escape') closeCrossing();
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); navigateCrossing(1); }
      if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { e.preventDefault(); navigateCrossing(-1); }
    });
  }

  function handleHash() {
    var hash = window.location.hash.replace('#', '');
    if (!hash) return;
    var code = hash.replace('-', '.');
    if (CROSSINGS[code]) {
      var cell = document.querySelector('.grid-cell[data-code="' + code + '"]');
      if (cell) {
        cell.scrollIntoView({ behavior: 'smooth', block: 'center' });
        cell.classList.add('highlighted');
        setTimeout(function() { openCrossing(code); }, 400);
      }
    }
  }

  // === BOOT ===
  async function boot() {
    fixContainers();
    var url = window.CROSSINGS_DATA_URL;
    if (!url) { console.error('CROSSINGS_DATA_URL not set'); return; }
    try {
      var resp = await fetch(url, { cache: 'no-cache' });
      var data = await resp.json();
      CROSSINGS = data.crossings || {};
      LEVELS = data.levels || {};
      STAGES = data.stages || {};
    } catch (err) {
      console.error('Failed to load crossings data:', err);
      return;
    }
    renderGrid();
    wireEvents();
    loadAllArtwork(); // pre-warm
    handleHash();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
